import { render, staticRenderFns } from "./editCustomerInfo.vue?vue&type=template&id=2fbaee70&scoped=true&"
import script from "./editCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./editCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./editCustomerInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editCustomerInfo.vue?vue&type=style&index=1&id=2fbaee70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbaee70",
  null
  
)

export default component.exports